exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navigation-container{position:absolute;bottom:50px;right:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/page-navigation/page-navigation.styl
// module id = 468
// module chunks = 0